import * as React from 'react';
import {useDispatch} from 'react-redux';
import {
    Dialog,
    DialogTitle,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import {Song} from '../../store/api/types';
import {useCreateUserPlaylist, useUserPlaylists} from '../../store/slices/userPlaylists/userPlaylistsSlice';
import {addTrack} from '../../store/slices/userPlaylists/reducers';
import {CreatePlaylistDialog} from './CreatePlaylistDialog';

interface PlaylistPickerDialogProps {
    open: boolean;
    onClose: () => void;
    song: Song | null;
    sourceImg?: string;
}

export const PlaylistPickerDialog: React.FC<PlaylistPickerDialogProps> = ({open, onClose, song, sourceImg}) => {
    const playlists = useUserPlaylists();
    const dispatch = useDispatch();
    const createUserPlaylist = useCreateUserPlaylist();
    const [showCreate, setShowCreate] = React.useState(false);

    const handlePick = (playlistId: string) => {
        if (song) {
            dispatch(addTrack({playlistId, song, sourceImg}));
        }
        onClose();
    };

    const handleCreateAndAdd = (name: string) => {
        const id = createUserPlaylist(name);
        if (song) {
            dispatch(addTrack({playlistId: id, song}));
        }
        setShowCreate(false);
        onClose();
    };

    return (
        <>
            <Dialog open={open && !showCreate} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle>Add to Playlist</DialogTitle>
                <List>
                    <ListItemButton onClick={() => setShowCreate(true)}>
                        <ListItemIcon><AddIcon/></ListItemIcon>
                        <ListItemText primary="New Playlist"/>
                    </ListItemButton>
                    {playlists.length > 0 && <Divider/>}
                    {playlists.map(pl => (
                        <ListItemButton key={pl.id} onClick={() => handlePick(pl.id)}>
                            <ListItemIcon><QueueMusicIcon/></ListItemIcon>
                            <ListItemText primary={pl.name} secondary={`${pl.tracks.length} songs`}/>
                        </ListItemButton>
                    ))}
                </List>
            </Dialog>

            <CreatePlaylistDialog
                open={showCreate}
                onClose={() => setShowCreate(false)}
                onConfirm={handleCreateAndAdd}
                title="New Playlist"
            />
        </>
    );
};
